import { Provider } from '@angular/core';
import { CookieRepository } from '@service/cookie.repository';
import { CookieServiceImpl } from '@adapter/security';

/**
 * Proveedor del repositorio de cookies
 */
const getCookieRepositoryProvider: Provider = {
  provide: CookieRepository,
  useClass: CookieServiceImpl
};

/**
 * Exportación de los proveedores de dependencias para cookies
 */
export const getCookieDi: Provider[] = [getCookieRepositoryProvider];
